import { ReactNode } from 'react';

import { useIsDesktop } from '@vk-hr-tek/ui/hooks';
import { Box } from '@vk-hr-tek/ui/Box';
import { Typography } from '@vk-hr-tek/ui/Typography';

interface PageHeaderProps {
  actions?: ReactNode | ReactNode[];
  additionalActions?: ReactNode | ReactNode[];
  link?: ReactNode;
  showTitleMobile?: boolean;
  title: ReactNode;
  actionsPosition?: 'default' | 'absolute';
  asWidget?: boolean;
}

export const PageHeader = ({
  actions,
  additionalActions,
  link,
  showTitleMobile = false,
  title: titleNode,
  actionsPosition = 'default',
  asWidget = false,
}: PageHeaderProps) => {
  const isDesktop = useIsDesktop();

  if (isDesktop) {
    return !!titleNode || actions || additionalActions ? (
      <Box pb="20">
        {link}
        <Box
          display="flex"
          justifyContent="space-between"
          mt={link ? '4' : '20'}
        >
          <Box flexGrow={1} mr="40" minWidth={0}>
            <Typography className="aqa_entity_header" variant="h4">
              {titleNode}
            </Typography>
          </Box>
          {actions ? (
            <Box alignItems="flex-start" display="flex">
              {actions}
            </Box>
          ) : (
            <Box alignItems="flex-start" display="flex">
              {additionalActions}
            </Box>
          )}
        </Box>
        {actions && additionalActions && (
          <Box mt={!!titleNode || !!actions ? '20' : '0'}>
            {additionalActions}
          </Box>
        )}
      </Box>
    ) : null;
  }

  return showTitleMobile || additionalActions ? (
    <Box pb="20" px={asWidget ? '0' : '16'}>
      {showTitleMobile ? (
        <Box display="flex" justifyContent="space-between">
          <Box flexGrow={1} mr="16">
            {link}
            <Box mt={link ? '4' : '0'}>
              <Box my="2">
                <Typography className="aqa_entity_header" variant="h5">
                  {titleNode}
                </Typography>
              </Box>
            </Box>
          </Box>
          {actions ? (
            <>
              {actionsPosition === 'absolute' && (
                <Box
                  position="absolute"
                  width="100%"
                  height="100%"
                  right="100%"
                >
                  <Box
                    display="flex"
                    mb="24"
                    position="sticky"
                    zIndex={100}
                    top="calc(100% - 72px)"
                    transform="translateX(100%)"
                    justifyContent="center"
                  >
                    {actions}
                  </Box>
                </Box>
              )}
              {actionsPosition === 'default' && (
                <Box alignItems="flex-end" display="flex">
                  {actions}
                </Box>
              )}
            </>
          ) : (
            <Box alignItems="flex-end" display="flex">
              {additionalActions}
            </Box>
          )}
        </Box>
      ) : (
        <Box position="absolute" width="100%" height="100%" right="100%">
          <Box
            display="flex"
            mb="24"
            position="sticky"
            zIndex={100}
            top="calc(100% - 72px)"
            transform="translateX(100%)"
            justifyContent="center"
          >
            {actions}
          </Box>
        </Box>
      )}
      {additionalActions && (
        <Box mt={showTitleMobile ? '16' : '0'}>{additionalActions}</Box>
      )}
    </Box>
  ) : null;
};
